module.exports = __webpack_public_path__ + "img/empty.01e09aec.png";